/**
 * This module works as an accordion on mobile,
 * but on desktop it turns into a tab system.
 */

'use strict';
import delegateListener from './delegate-listener';

var accordionTab = {
  _breakpoint: 768, // When to move from accordion to tab
  _accordionTabs: [],

  init: function() {
    this._accordionTabs = document.querySelectorAll('.accordion-tab');

    if(this._accordionTabs.length > 0) {
      // Bind events
      window.onresize = this._debounce(this._onWindowResize.bind(this), 200);
      window.onhashchange = this._onHashChange.bind(this);
      document.body.addEventListener('change', delegateListener('.accordion-tab__radio', this._onInputChange.bind(this)));
      document.body.addEventListener('click', delegateListener('.accordion-tab__label', this._onLabelClick.bind(this)));

      // Run once on init
      this._forceOpenOnDesktop();
      this._activateTabFromHash();
    }
  },

  /**
   * Handles input change event
   *
   * @param {object} event - Event object
   */
  _onInputChange(event) {
    const itemHash = event.target.dataset.urlHash;
    if(itemHash) {
      window.location.hash = itemHash;
    }
    if(this._isDesktop()) return;
    const parent = event.target.parentElement;
    parent.scrollIntoView();
  },

  /**
   * Unchecks the radio when open accordion's label is clicked
   *
   * @param {Event} event - The delegateListener event object
   */
  _onLabelClick(event) {
    if(this._isDesktop()) return; // normal behavior for desktop labels;
    const input = document.getElementById(
      event.delegateTarget.htmlFor || ''
    );
    if(!input) return;
    if(input.checked) {
      input.checked = false;
      event.preventDefault();
    }
  },

  /**
   * Handles window resize event.
   * Debounced.
   */
  _onWindowResize: function() {
    this._forceOpenOnDesktop();
  },

  /**
   * Handles hashchange event
   *
   * @param {object} event - Event object
   */
  _onHashChange: function(event) {
    this._activateTabFromHash();
  },

  /**
   * On mobile all accordion items should be closed by default
   * On desktop, first should be open on default
   */
  _forceOpenOnDesktop() {
    if(this._isDesktop()) {
      Array.from(this._accordionTabs).forEach(element => {
        if(element.querySelectorAll('.accordion-tab__radio:checked').length === 0) {
          element.querySelector('.accordion-tab__radio').checked = true;
        }
      });
    }
  },

  _isDesktop() {
    return (
      window.innerWidth >= this._breakpoint &&
      this._accordionTabs.length
    );
  },

  /**
   * Opens tab from hash
   */
  _activateTabFromHash() {
    const hash = window.location.hash.split('#')[1];
    const input = document.querySelector('.accordion-tab__radio[id*="' + hash + '"]');

    if(input) {
      input.dispatchEvent(new Event('click', { bubbles: true }));
    }
  },

  /**
   * Debounce function
   *
   * @param {function} func - Function to run
   * @param {number} wait - Wait time in milliseconds
   * @param {boolean} immediate - Run immediately or not
   *
   * @returns {function}
   */
  _debounce(func, wait, immediate) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        if(!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if(callNow) func.apply(context, args);
    };
  }

};

module.exports = accordionTab;
